<template>
  <div>
    <el-table
      :data="PreviewData"
      stripe
      resizable
      size="mini"
      :header-cell-style="{ 'background-color': '#f8f8f9', color: '#262626' }"
      class="table_list table_border"
      :row-style="rowStyle"
      :height="tableHeight"
    >
      <el-table-column type="index" title="#" width="50"></el-table-column>
      <el-table-column
        v-for="(list, i) in PreviewLabelData"
        :key="i"
        :prop="list.prop"
        :min-width="list.width"
        :label="list.label"
      ></el-table-column>
    </el-table>
    <el-row style="padding: 10px 0 0 0">
      <el-col :span="24" class="text-R">
        <el-tooltip
          effect="dark"
          :content="$t('message.Save')"
          placement="top"
        >
          <el-button
            type="primary"
            size="mini"
            icon="iconfont icon-baocun1"
            :loading="btnLoading"
            :disabled="isSubmit"
            @click="excelAction"
          ></el-button>
        </el-tooltip>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["PreviewData", "PreviewLabelData", "updateFlag"], //父级传入数据源,updateFlag为0，显示数据修改
  data() {
    return {
      isSubmit: false,
      btnLoading: false,
      tableHeight: 0,
      tableWidth: 0,
    };
  },
  created() {
    this.getHeight();
    console.log(this.PreviewData)
    console.log(this.PreviewLabelData)
  },
  computed: {},
  mounted() {
    let that = this;
    window.addEventListener("resize", function () {
      that.getHeight();
    });
    this.fetchData();
  },
  methods: {
    rowStyle({ row, rowIndex }) {
      //数据错误
      if (!row.IsSuccess) {
        return {
          backgroundColor: "#fddddd!important",
        };
      }
    },
    //获取数据
    fetchData() {
      for (let i in this.PreviewData) {
        if (this.PreviewData[i].IsSuccess == false) {
          this.isSubmit = true;
        }
      }
    },
    excelAction() {
      this.btnLoading = true;
      this.$emit("excelAction");
    },
    //计算页面高度
    getHeight() {
      this.tableHeight = window.innerHeight - 350;
    },
  },
};
</script>

<style scoped>
.text-R{text-align: right}
.preview-data {
  display: flex;
}

.preview-data ul {
  flex: 1;
  vertical-align: top;
}

.preview-data ul h1 {
  line-height: 30px;
  font-size: 12px;
  padding: 0 6px;
  margin: 0;
  font-weight: 800;
  color: rgb(0, 0, 0);
  background: #fafafa;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.preview-data ul li {
  height: 35px;
  font-size: 12px;
  padding: 8px 6px;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.preview-data ul:last-child h1 {
  border-right: 0;
}

.preview-data ul:last-child li {
  border-right: 0;
}

.error {
  background: #fddddd !important;
}

.tips {
  background: #e6fcd9;
}

.warning {
  background: #feedce;
}

/*黄色*/
</style>
